import { useEffect } from "react"
import { changeLocale } from "../../i18n"
import { DiplomaPreviewLocked } from "./DiplomaPreviewLocked"
import { DiplomaPreviewUnlocked } from "./DiplomaPreviewUnlocked"
import type { DiplomaPreviewProps } from "./types"

import s from "./DiplomaPreview.module.scss"

export const DiplomaPreview = (props: DiplomaPreviewProps) => {
  const { productLink, productTitle, title, contentLocale, isUnlocked } = props

  useEffect(() => {
    changeLocale(contentLocale)
  }, [contentLocale])

  return (
    <div className={s.diplomaPreview}>
      {isUnlocked ? (
        <DiplomaPreviewUnlocked {...props} />
      ) : (
        <DiplomaPreviewLocked
          title={title}
          productTitle={productTitle}
          productLink={productLink}
        />
      )}
    </div>
  )
}
